import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function EliminarProdCertificado({
  registro = {},
  onClose = () => {},
  onDeleted = () => {},
}) {
  const [loading, setLoading] = useState(false);
  // ELIMINADO: const [error, setError] = useState(""); 

  const handleDelete = async () => {
    // ELIMINADO: setError("");
    setLoading(true);

    try {
      const id = registro.id;
      if (!id) throw new Error("ID de registro no encontrado.");

      // Usamos la ruta configurada para Detalle de Certificados
      const url = apiRoutes.certificadoDetalles.deleteUrl(id);
      
      await appFetchJson(url, { method: "DELETE" });

      onDeleted();
      onClose();
    } catch (e) {
      console.error("Error al eliminar el producto del certificado:", e);
      // ELIMINADO: Lógica de mensaje local duplicada.
      // La alerta global del sistema se encargará de mostrar el error.
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <div className="px-6 py-4 border-b">
        <h2 className="section-title">Eliminar Producto de Certificado</h2>
      </div>

      <div className="px-6 pt-4">
        <div className="mb-4 px-4 py-3 text-sm text-blue-600">
          ¿Está seguro que desea eliminar esta asignación?
        </div>

        {/* Resumen de datos a eliminar */}
        <div className="bg-gray-50 px-6 py-6 mb-2 space-y-2">
          <div>
            <span className="text-gray-500 mr-1">Certificado:</span>
            <span className="font-medium">
                {registro.certificadoNumero ?? "—"}
            </span>
          </div>

          <div>
            <span className="text-gray-500 mr-1">Producto:</span>
            <span className="font-medium">
                {registro.productoCodigo} - {registro.productoNombre}
            </span>
          </div>

          <div>
            <span className="text-gray-500 mr-1">Monto Descuento:</span>
            <span className="font-medium">
                {new Intl.NumberFormat("es-PY").format(registro.valorMontoDescuento || 0)}
            </span>
          </div>
        </div>
        
        {/* ELIMINADO: Bloque que renderizaba el error rojo local */}
      </div>

      <div className="px-6 py-4 border-t flex gap-2 modal-footer">
        <button className="btn-fil" onClick={handleDelete} disabled={loading}>
          {loading ? "Eliminando…" : "Eliminar"}
        </button>

        <button className="btn-fil" onClick={onClose}>
          Cancelar
        </button>
      </div>
    </div>
  );
}